import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";
import { CasinoCard } from "@/components/CasinoCard";
import { listCasinos } from "@/data/casinos";
import { FAQ, buildFAQSchema } from "@/components/FAQ";

export function FreeSpinsPage() {
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const casinos = listCasinos();
  const title = isSv
    ? "Free spins 2026 — bästa casinon med gratissnurr"
    : "Free spins 2026 — best casinos with free spins";
  const desc = isSv
    ? "Få free spins som en del av välkomstbonusen eller löpande kampanjer. Vi förklarar villkor, omsättningskrav och giltighetstid."
    : "Free spins as part of welcome offers or recurring promotions. We explain terms, wagering and validity.";

  const faq = [
    {
      question_sv: "Är free spins-vinster mina egna pengar?",
      question_en: "Are free spins winnings my own money?",
      answer_sv:
        "Vinsten från free spins blir bonuspengar som omfattas av omsättningskrav. Du måste alltså spela igenom dem innan de kan tas ut.",
      answer_en:
        "Winnings from free spins are bonus money subject to a wagering requirement. You must wager them through before withdrawal.",
    },
    {
      question_sv: "Vilken slot kör free spins-rundorna på?",
      question_en: "Which slot do free spins run on?",
      answer_sv:
        "Casinot bestämmer vilken slot. Det är ofta en populär titel som Book of Dead, Starburst eller Sweet Bonanza.",
      answer_en:
        "The casino decides the slot. It is usually a popular title like Book of Dead, Starburst or Sweet Bonanza.",
    },
  ];
  return (
    <div className="container-page py-8">
      <SEO title={title} description={desc} jsonLd={buildFAQSchema(faq, lang)} />
      <Breadcrumbs items={[{ label: t("nav.home"), href: prefix }, { label: title }]} />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{title}</h1>
      <p className="mt-2 max-w-3xl text-ink-700">{desc}</p>

      <article className="prose prose-ink mt-6 max-w-3xl [&>h2]:mt-8 [&>h2]:mb-3 [&>h2]:text-2xl [&>h2]:font-bold [&>p]:my-3">
        <h2>{isSv ? "Vad är free spins?" : "What are free spins?"}</h2>
        <p>
          {isSv
            ? "Free spins är gratissnurr på en specifik spelautomat. De ges typiskt som del av ett välkomsterbjudande eller en återkommande kampanj. Insatsen per snurr är fast — vanligen 1 kr — och vinsten räknas som bonuspengar med omsättningskrav."
            : "Free spins are free rounds on a specific slot. They typically come as part of a welcome offer or a recurring promotion. The bet per spin is fixed — typically 1 SEK — and winnings count as bonus money subject to wagering."}
        </p>
        <h2>{isSv ? "Vad du ska kontrollera" : "What to check"}</h2>
        <p>
          {isSv
            ? "Den slot snurren körs på, omsättningskravet på vinsten, hur länge bonusen är giltig och om det finns ett max-tak på vinsten. Vissa casinon begränsar free spins-vinster till ett maxbelopp — vilket kan kännas surt om du får en stor träff."
            : "The slot the spins run on, the wagering on winnings, how long the bonus stays valid, and whether there is a cap on winnings. Some casinos cap free spins winnings — which can sting if you hit a big win."}
        </p>
      </article>

      <h2 className="mt-10 text-2xl font-bold">
        {isSv ? "Casinon med free spins" : "Casinos with free spins"}
      </h2>
      <div className="mt-4 grid gap-4">
        {casinos.map((c, i) => (
          <CasinoCard key={c.id} casino={c} rank={i + 1} source="free-spins" />
        ))}
      </div>

      <div className="mt-10">
        <FAQ items={faq} />
      </div>

      <InternalLinks context="bonus" />
    </div>
  );
}
